import React from 'react';
import { useNavigate } from "react-router-dom";

const BotonVolver = () => {
  const navigate = useNavigate();

  return (
    <>
      <button onClick={() => navigate(-1)} className="btn btn-primary ms-3 mb-0" >Volver</button>
    </>
  );
};

export default BotonVolver;